export default __webpack_public_path__ + "static/media/backgroundEmUmContratoMobile.dc289617.png";